/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { completeFeatureTour } from './featureTourApi';
import { TOUR_STEPS_VERSION } from './steps';
import { FeatureTourState } from './types';

const initialState: FeatureTourState = {
    isRunning: false,
    stepIndex: 0,
    stepsVersion: TOUR_STEPS_VERSION,
    isMarkingSeen: false,
};

export const featureTourSlice = createSlice({
    name: 'featureTour',
    initialState,
    reducers: {
        startTour: (state) => {
            // A stepIndex persisted against an older step list can't be trusted.
            if (state.stepsVersion !== TOUR_STEPS_VERSION) {
                state.stepIndex = 0;
                state.stepsVersion = TOUR_STEPS_VERSION;
            }
            state.isRunning = true;
        },
        setStepIndex: (state, action: PayloadAction<number>) => {
            state.stepIndex = Math.max(0, action.payload);
        },
        endTour: (state) => {
            state.isRunning = false;
            state.stepIndex = 0;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(completeFeatureTour.pending, (state) => {
                state.isMarkingSeen = true;
                state.isRunning = false;
                state.stepIndex = 0;
            })
            .addCase(completeFeatureTour.fulfilled, (state) => {
                state.isMarkingSeen = false;
            })
            .addCase(completeFeatureTour.rejected, (state) => {
                state.isMarkingSeen = false;
            });
    },
});

export const { startTour, setStepIndex, endTour } = featureTourSlice.actions;

export default featureTourSlice.reducer;
